import { Autocomplete, Box, FormControl, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "~/app/store";
import {
  newSettingsAutocompleteTextFieldSx,
  overviewAutocompleteSx,
  overviewAutocompleteTagsDisplaySx
} from "~/features/preview/workstation/workstation.styles";
import { workstationRoles } from "~/lib/helpers";
import { selectUserIsAdmin } from "~/redux/selectors/authSelectors";
import { UpdateWorkstation } from "~/types/api";

export function WorkstationRolesSelect() {
  const { t } = useTranslation();
  const isAdmin = useAppSelector(selectUserIsAdmin);
  const { control } = useFormContext<UpdateWorkstation>();

  return (
    <FormControl fullWidth size="small">
      <Controller
        name="roles"
        control={control}
        render={({ field: { onChange, value } }) => (
          <Autocomplete
            fullWidth
            multiple
            size="small"
            autoComplete={false}
            disableCloseOnSelect
            disableClearable
            disabled={!isAdmin}
            options={workstationRoles}
            value={value}
            onChange={(_, values) => onChange(values)}
            aria-label={t("workstation roles overview aria label")}
            sx={overviewAutocompleteSx}
            getOptionDisabled={(option) => {
              const roles = value ?? [];
              return (
                roles.length === 1 &&
                roles[0].toLowerCase() === option.toLowerCase()
              );
            }}
            renderTags={(tagValue) => (
              <Box component="span" sx={overviewAutocompleteTagsDisplaySx}>
                {tagValue.join(", ")}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                slotProps={{
                  htmlInput: {
                    ...params.inputProps,
                    readOnly: true,
                    "aria-label": t("workstation roles overview aria label")
                  }
                }}
                sx={newSettingsAutocompleteTextFieldSx}
              />
            )}
          />
        )}
      />
    </FormControl>
  );
}
